import { mainActionTypes } from './main.types';


// CANVAS STARTED
// --------------------------------------------------------------
export const mainCanvasStarted = () => ({
    type: mainActionTypes.MAIN_CANVAS_STARTED,
});

// FETCH DIAGRAM
// --------------------------------------------------------------
export const fetchDiagramMain = (diagramId) => ({
    type: mainActionTypes.MAIN_FETCH_DIAGRAM_REQUEST,
    payload: { diagramId },
});
export const fetchDiagramSuccessMain = (data) => ({
    type: mainActionTypes.MAIN_FETCH_DIAGRAM_SUCCESS,
    payload: { data },
});
export const fetchDiagramFailureMain = error => ({
    type: mainActionTypes.MAIN_FETCH_DIAGRAM_FAILURE,
    payload: error,
});

// CLEAR DIAGRAM ERRORS (ON FETCH DIAGRAM)
// --------------------------------------------------------------
export const clearDiagramErrors = (id) => ({
    type: mainActionTypes.MAIN_CLEAR_DIAGRAM_ERRORS,
});

// MODAL DIAGRAM DETAILS
// --------------------------------------------------------------
export const toggleDiagramDetails = (page, id) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_DETAILS,
    payload: { page, id },
});
export const toggleTemplateDetails = (id) => ({
    type: mainActionTypes.TOGGLE_MODAL_TEMPLATE_DETAILS,
    payload: { id },
});

// DIAGRAM RENAME
// --------------------------------------------------------------
export const diagramRename = (id, body) => ({
    type: mainActionTypes.MAIN_DIAGRAM_RENAME_REQUEST,
    payload: { id, body },
});

// MODAL FEEDBACK / SUPPORT
// --------------------------------------------------------------
export const toggleSupport = (type) => ({
    type: mainActionTypes.TOGGLE_MODAL_SUPPORT,
    payload: { type },
});
export const sendFeedback = (data) => ({
    type: mainActionTypes.SUPPORT_REQ_REQUEST,
    payload: { data },
});
export const sendFeedbackSuccess = (data) => ({
    type: mainActionTypes.SUPPORT_REQ_SUCCESS,
    payload: { data },
});
export const sendFeedbackFailure = error => ({
    type: mainActionTypes.SUPPORT_REQ_FAILURE,
    payload: error,
});
export const clearFeedbackSentStatus = (id) => ({
    type: mainActionTypes.MAIN_CLEAR_FEEDBACK_SENT_STATUS,
});

// MODAL FEEDBACK THANKS
// --------------------------------------------------------------
export const toggleModalFeedbackThanks = (type) => ({
    type: mainActionTypes.TOGGLE_MODAL_FEEDBACK_THANKS,
    payload: { type },
});

// MODAL DIAGRAM QUICK SHARE
// --------------------------------------------------------------
export const toggleModalDiagramQuickShare = (type) => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_QUICK_SHARE,
    payload: { type },
});
export const disableModalDiagramQuickShare = (type) => ({
    type: mainActionTypes.DISABLE_MODAL_DIAGRAM_QUICK_SHARE,
    payload: { type },
});


// LOAD NEW PROJECT
// --------------------------------------------------------------
export const loadNewProject = () => ({
    type: mainActionTypes.LOAD_NEW_PROJECT,
});

// LOAD QUICK SHARE PROJECT
// --------------------------------------------------------------
export const loadQuickShareProject = (diagramDetails) => ({
    type: mainActionTypes.LOAD_QUICK_SHARE_PROJECT,
    payload: { diagramDetails },
});

// LOAD SAMPLE PROJECT DETAILS
// --------------------------------------------------------------
export const loadSampleProjectDetails = () => ({
    type: mainActionTypes.LOAD_SAMPLE_PROJECT_DETAILS,
});

// DIAGRAM CREATE NEW
// --------------------------------------------------------------
export const toggleDiagramCreateNew = () => ({
    type: mainActionTypes.TOGGLE_MODAL_DIAGRAM_CREATE_NEW,
});

// ADD NEW DIAGRAM
export const addNewDiagram = (dbEngine) => ({
    type: mainActionTypes.ADD_NEW_DIAGRAM,
    payload: { dbEngine },
});



// MODAL LANGUAGES
// --------------------------------------------------------------
export const toggleModalLanguages = () => ({
    type: mainActionTypes.TOGGLE_MODAL_LANGUAGES,
});

// SET LANGUAGE
export const setLanguage = (language) => ({
    type: mainActionTypes.SET_LANGUAGE,
    payload: { language },
});


// LOAD QUICK SHARE PROJECT
// --------------------------------------------------------------
export const handleQuickShareError = () => ({
    type: mainActionTypes.HANDLE_QUICK_SHARE_ERROR,
});

